if (!customElements.get('for-skin-access')) {
  customElements.define('for-skin-access', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const signup = this.querySelector('[data-signup-panel]');
      const password = this.querySelector('[data-password-panel]');
      const back = this.querySelector('[data-signup-open]');
      if (!signup || !password || !back) return;
      this.dataset.enhanced = 'true';
      password.addEventListener('toggle', () => {
        signup.hidden = password.open;
        this.setAttribute('aria-labelledby', password.open
          ? this.querySelector('[data-password-heading]').id
          : signup.querySelector('h1').id);
        if (password.open) password.querySelector('input[type="password"]').focus();
      });
      this.querySelector('[data-password-heading]').id = `${password.querySelector('form').id}-heading`;
      back.addEventListener('click', () => {
        password.open = false;
        signup.hidden = false;
        signup.querySelector('input[type="email"]')?.focus();
      });
      if (password.querySelector('[data-password-error]')) password.open = true;
    }
  });
}
